import type {FC} from "react";
import {memo, useCallback, useMemo} from "react";

import {buildChannel} from "../../models/channel";
import type {SelectChannelType} from "../../models/listing";
import ChannelLogo from "../ChannelLogo";
import TabItem from "../Tabs/TabItem";

type Props = {
    testID?: string;
    active?: boolean;
    channel: SelectChannelType;
    onChangeChannel: (channel: SelectChannelType) => void;
};

const ChannelTabItem: FC<Props> = ({testID, channel, active, onChangeChannel}) => {
    const handleChangeChannel = useCallback(() => {
        onChangeChannel(channel);
    }, [channel, onChangeChannel]);

    const option = useMemo(() => {
        return channel !== "all" ? buildChannel(channel) : undefined;
    }, [channel]);

    return (
        <TabItem
            active={active}
            id={channel}
            leftIcon={channel !== "all" ? <ChannelLogo channel={channel} /> : undefined}
            testID={testID}
            onPress={handleChangeChannel}
        >
            {option ? option.label : "All"}
        </TabItem>
    );
};

export default memo(ChannelTabItem);
